import React, { useRef, useState } from "react";
import { useFormik } from "formik";
import { categoryList } from "../data/categories";
import { MultiSelect } from "primereact/multiselect";
import { axiosWithoutHeader } from "../api/axios";
import {
  TextField,
  Button,
  Grid,
  Autocomplete,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Dropdown } from "primereact/dropdown";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from "@mui/material/Slide";

const ADDUSER_URL = "/account/register";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const AddUser = ({ reloadData, hidePopup, existinguser }) => {
  const [eyeSlashPassword, seteyeSlashPassword] = useState(false);
  const [eyeSlashConfirmPassword, seteyeSlashConfirmPassword] = useState(false);
  const [submitdisbale, setsubmitdisbale] = useState(false);
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState(false);
  const [message, setMessage] = useState(false);

 const  existingUserCategory=()=>{
  const existingUserCat=categoryList.filter((e)=>{
    return existinguser.categoryId?.includes(e.id)
  }) 
  return existingUserCat
 }
 
  const formik = useFormik({
    validateOnBlur: true, // Disable onBlur validation
    validateOnChange: true, // Disable onChange validation
    initialValues: {
      category:existinguser?existingUserCategory(): [
        {
          id: 1,
          category: "Income Tax Act, 1961",
        },
      ],
      referenceName: existinguser ? existinguser.referenceName : "",
      email: existinguser ? existinguser.email : "",
      password: "",
      confirmPassword: "",
      phone: existinguser ? existinguser.phone : "",
      phoneinfo:null
    },
    validate: (values) => {
      const errors = {};

      if (!values.referenceName) {
        errors.referenceName = "Please enter  name";
      } else if (values.referenceName.length < 2) {
        errors.referenceName = "Name must be longer than 1 character";
      }

      if (!values.email) {
        errors.email = "Please enter  email";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
      ) {
        errors.email = "Please enter a valid email address";
      }

      if (!values.phone) {
        errors.phone = "Please enter phone number";
      }
      else if( values.phoneinfo && !values.phoneinfo.nationalNumber.length){
        errors.phone = "Please enter  phone number";
      }
      if (!values.category ) {
        errors.category = "Please select department";
      }

      if (!existinguser) {
       

        if (!values.password) {
          errors.password = "Please enter password";
        } else if (values.password.length < 7) {
          errors.password = "Password must be longer than 6 characters";
        } else if (values.password.length >= 20) {
          errors.password = "Password must be shorter than 20 characters";
        }

        if (!values.confirmPassword) {
          errors.confirmPassword = "Password confirmation is required";
        } else if (values.confirmPassword !== values.password) {
          errors.confirmPassword =
            "Confirm password doesn't match with password";
        }
      }
      console.log("value", values);

      return errors;
    },
    onSubmit: async (values) => {
      const idArray = values.category?.map(item => item.id);
   
      const data = {
        referenceName: values.referenceName,
        username: values.email,
        email: values.email,
        password: existinguser ? "####" : values.password,
        phone: values.phone,
        accountId: existinguser ? existinguser.id : undefined,
        categoryId: idArray,
      };

      try {
        const response = await axiosWithoutHeader.post(ADDUSER_URL, data);

        if (response.status === 200) {
          setOpen(true);
          setSeverity('success');
          setMessage(response.data.error);
          reloadData();
          setsubmitdisbale(true);
          setTimeout(() => {
            hidePopup(false);
            setsubmitdisbale(false);
          }, 3000);
        } else {
          setOpen(true);
          setSeverity('error');
          setMessage(response.data.error);
        }
      } catch (err) {
        setOpen(true);
        setSeverity('error');
        setMessage(err.response.data.error);
      }
    },
  });

  const handleClose = async () => {
    setOpen(false);
  };


  return (
    <>
      <Snackbar
    open={open}
    autoHideDuration={5000}
    onClose={handleClose}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
    TransitionComponent={SlideTransition}
    >
    <Alert
        onClose={handleClose}
        severity= {severity}
        variant="filled"
        sx={{ width: "100%" }}
    >
        {message}
    </Alert>
    </Snackbar>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={3} marginTop={"16px"}>
          {
            <Grid item xs={12} className="form">
              <div className="form-group d-flex flex-column-reverse position-relative">
                <span className="text-danger customerror">
                  {formik.errors.category}
                </span>
                <MultiSelect
                  style={{ width: "100%" }}
                  value={formik.values.category}
                  options={categoryList}
                  onChange={(e) =>
                    formik.setFieldValue("category", e.value ? e.value : null)
                  }
                  optionLabel="category"
                  autoFocus
                  showClear={true}
                  id="category"
                  name="category"
                  className={formik.errors.category && "customerrorbox"}
                  filter
                  resetFilterOnHide
                  filterPlaceholder="Search Department"
                  error={formik.touched.category && formik.errors.category}
                  helperText={formik.touched.category && formik.errors.category}
                />

                <label
                  htmlFor="category"
                  className={`${
                    formik.errors.category && "custpmerrorfont"
                  }   addUserClass`}
                >
                  Category
                </label>
              </div>
            </Grid>
          }

          <Grid item xs={12}>
            <TextField
              id="referenceName"
              label="Name"
              autoComplete="off"
              fullWidth
              onChange={formik.handleChange}
              className="custom-inputField"
              {...formik.getFieldProps("referenceName")}
              error={
                formik.touched.referenceName && formik.errors.referenceName
              }
              helperText={
                formik.touched.referenceName && formik.errors.referenceName
              }
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              id="email"
              label="Email"
              autoComplete="off"
              fullWidth
              onChange={formik.handleChange}
              className="custom-inputField"
              {...formik.getFieldProps("email")}
              error={formik.touched.email && formik.errors.email}
              helperText={formik.touched.email && formik.errors.email}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          {!existinguser && (
            <>
              <Grid item xs={12}>
                <TextField
                  type={eyeSlashPassword ? "text" : "password"}
                  id="password"
                  label="Password"
                  placeholder="6+ strong characters"
                  autoComplete="off"
                  fullWidth
                  onChange={formik.handleChange}
                  className="custom-inputField"
                  {...formik.getFieldProps("password")}
                  error={formik.touched.password && formik.errors.password}
                  helperText={formik.touched.password && formik.errors.password}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => seteyeSlashPassword(!eyeSlashPassword)}
                          edge="end"
                        >
                          {eyeSlashPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  type={eyeSlashConfirmPassword ? "text" : "password"}
                  id="confirmPassword"
                  label="Confirm Password"
                  placeholder="6+ strong characters"
                  autoComplete="off"
                  fullWidth
                  onChange={formik.handleChange}
                  className="custom-inputField"
                  {...formik.getFieldProps("confirmPassword")}
                  error={
                    formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                  }
                  helperText={
                    formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            seteyeSlashConfirmPassword(!eyeSlashConfirmPassword)
                          }
                          edge="end"
                        >
                          {eyeSlashConfirmPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </>
          )}

          <Grid item xs={12}>
            <MuiTelInput
              forceCallingCode
              className="custom-inputField "
              label="Phone Number"
              fullWidth
              defaultCountry="IN"
              value={formik.values.phone}
              onChange={(value,info) =>
                formik.setValues({
                  ...formik.values,
              phoneinfo: info,
              phone: value.replace(/\s+/g, "")
            })
              }
              onBlur={formik.handleBlur("phone")}
              error={formik.touched.phone && Boolean(formik.errors.phone)}
              helperText={formik.touched.phone && formik.errors.phone}
            />
          </Grid>
        </Grid>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          disabled={submitdisbale}
          className="btn btn-primary btn-h"
          type="submit"
          style={{ marginTop: "20px" }}
        >
          {existinguser ? "SUBMIT" : "Add Consultant"}
        </Button>
      </form>
    </>
  );
};

export default AddUser;
